var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-table',{staticClass:"mb-5 table-dropdown no-scrollbar border rounded",attrs:{"bordered":"","striped":"","responsive":"","items":_vm.exams,"fields":_vm.examFields,"show-empty":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }